/**
 * @param {string} code - Bank code
 * @param {('short'|'long')} type - Logo type
 */
export const bankNameHandler = (code, type = 'short') => {
	let bankName = ''

	if (type === 'short') {
		switch (code) {
			case '002':
				bankName = 'Bank BRI'
				break
			case '008':
				bankName = 'Bank Mandiri'
				break
			case '014':
				bankName = 'Bank BCA'
				break
			case '022':
				bankName = 'Bank BCA'
				break
			case '037':
				bankName = 'Bank AGI'
				break
			case '451':
				bankName = 'Bank BSI'
				break
			default:
				bankName = ''
		}
	} else if (type === 'long') {
		switch (code) {
			case '002':
				bankName = 'Bank Rakyat Indonesia'
				break
			case '008':
				bankName = 'Bank Mandiri'
				break
			case '014':
				bankName = 'Bank Central Asia'
				break
			case '022':
				bankName = 'Bank Central Asia'
				break
			case '037':
				bankName = 'Bank Artha Graha Internasional'
				break
			case '451':
				bankName = 'Bank Syariah Indonesia'
				break
			default:
				bankName = ''
		}
	}

	return bankName
}